import $store from '#/store'
import { Route } from 'vue-router'

/**
 * Forget scroll position on route change
 */
export const scrollBehavior = (to: Route, from: Route, savedPosition: Route) => (to.hash ? { selector: to.hash } : savedPosition || { x: 0, y: 0 })

/**
 * redirect operations
 */
export function redirect(to: Route, from: Route, next: any) {
    if (to.matched.some(record => record.meta.requiresAuth) && !$store.getters['auth/isAuthenticated']) {
        /*
         * If the user is not authenticated and visits a page that requires authentication, show login
         */
        next({ name: 'Login' })
    }
    next()
}
